// removed by extract-text-webpack-plugin
module.exports = {"root":"Header__root___3PJ4b","logo":"Header__logo___1X8sF","title":"Header__title___3dl6f"};